import { useEffect, useState } from 'react';

export function useOfflineStatus() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const onOnline = () => setIsOffline(false);
    const onOffline = () => setIsOffline(true);

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return isOffline;
}

export function OfflineBanner() {
  const isOffline = useOfflineStatus();
  if (!isOffline) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2147483647,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          margin: '8px',
          background: '#111',
          color: 'white',
          borderRadius: 9999,
          padding: '8px 12px',
          fontSize: 12,
          boxShadow: '0 8px 24px rgba(0,0,0,.2)',
        }}
      >
        You are offline. Some features may be unavailable.
      </div>
    </div>
  );
}
